













































import { Component, Vue, Watch } from 'vue-property-decorator';
import { FORMAT_CURRENCY } from '@/utils/formatPrice';
import { IArticle } from "@/interfaces/IArticle";
import { GetterNames } from "@/constants/GetterNames";
import { ActionNames } from "@/constants/ActionNames";
import Loading from '@/components/Loading.vue';

@Component({
  components: {
    Loading,
  },
})
export default class Modal extends Vue {
  public loading: boolean = false;

  public selectedPackage: number = 0;

  public error: {
    type: string,
    message: string,
    show: boolean,
  } = {
    show: false,
    type: '',
    message: '',
  };

  public formatCurrency = (price: number): string => FORMAT_CURRENCY(price);

  get articles(): IArticle[] {
    return this.$store.getters[GetterNames.ARTICLES];
  }

  get relationId(): number {
    return this.$store.getters[GetterNames.RELATION_ID];
  }

  @Watch('relationId', { immediate: true, deep: true })
  public async onRelationIdChange() {
    if (this.relationId !== 0) {
      this.loading = true;

      await this.$store.dispatch(ActionNames.GET_ARTICLES);

      this.loading = false;
    }
  }

  public async createOrder() {
    this.loading = true;

    if (this.selectedPackage !== 0) {
      const success = await this.$store.dispatch(ActionNames.CREATE_ORDER, this.selectedPackage);

      if (!success) {
        this.error = {
          show: true,
          type: 'warning',
          message: 'Er ging iets mis tijdens het maken van een order',
        };
      } else {
        this.error = {
          show: true,
          type: 'success',
          message: 'Je word nu doorgestuurd naar de betaalpagina',
        };

        return;
      }
    } else {
      this.error = {
        show: true,
        type: 'warning',
        message: 'Selecteer het bedrag wat je wilt opwaarderen',
      };
    }

    this.loading = false;
  }
}
